import bannerFarmDesk from '../../assets/images/Farm/19-04-23-banner-farm-desktop.jpg'
import bannerCrisBarros from '../../assets/images/bannerCrisBarros.svg'
import bannerFoxton from '../../assets/images/bannerFoxton.svg'
import bannerMariaFiloDesk1 from '../../assets/images/mariaFilo/mariaFilo_desk_banner_1.jpg'
import bannerMariaFiloDesk2 from '../../assets/images/mariaFilo/mariaFilo_desk_banner_2.jpg'
import bannerMariaFiloDesk3 from '../../assets/images/mariaFilo/mariaFilo_desk_banner_3.jpg'
import bannerMariaFiloDesk4 from '../../assets/images/mariaFilo/mariaFilo_desk_banner_4.jpg'
import bannerMariaFiloDesk5 from '../../assets/images/mariaFilo/mariaFilo_desk_banner_5.jpg'
import bannerFabulaDesk1 from '../../assets/images/Fabula/fabula_desk_banner_1.png'
import bannerFabulaDesk2 from '../../assets/images/Fabula/fabula_desk_banner_2.png'
import bannerFabulaDesk3 from '../../assets/images/Fabula/fabula_desk_banner_3.png'
import bannerOffPremiumAmarelo1Desk from '../../assets/images/offPremium/banner_desk_amarelo_1.jpg'
import bannerOffPremiumAmarelo2Desk from '../../assets/images/offPremium/banner_desk_amarelo_2.jpg'
import bannerOffPremiumRosa1Desk from '../../assets/images/offPremium/banner_desk_rosa_1.jpg'
import bannerOffPremiumRosa2Desk from '../../assets/images/offPremium/banner_desk_rosa_2.jpg'

import bannerFarmMob from '../../assets/images/Farm/19-04-23-banner-farm-mobile.jpg'
import bannerAnimaleDesk1 from '../../assets/images/Animale/Animale_desktop_banner_1.png'
import bannerAnimaleDesk2 from '../../assets/images/Animale/Animale_desktop_banner_2.png'
import bannerAnimaleDesk3 from '../../assets/images/Animale/Animale_desktop_banner_3.png'
import bannerMariaFiloMob1 from '../../assets/images/mariaFilo/mariaFilo_mob_banner_1.jpg'
import bannerMariaFiloMob2 from '../../assets/images/mariaFilo/mariaFilo_mob_banner_2.jpg'
import bannerMariaFiloMob3 from '../../assets/images/mariaFilo/mariaFilo_mob_banner_3.jpg'
import bannerMariaFiloMob4 from '../../assets/images/mariaFilo/mariaFilo_mob_banner_4.jpg'
import bannerMariaFiloMob5 from '../../assets/images/mariaFilo/mariaFilo_mob_banner_5.jpg'
import bannerFabulaMob1 from '../../assets/images/Fabula/fabula_mob_banner_1.png'
import bannerFabulaMob2 from '../../assets/images/Fabula/fabula_mob_banner_2.png'
import bannerFabulaMob3 from '../../assets/images/Fabula/fabula_mob_banner_3.png'
import bannerOffPremiumAmarelo1Mob from '../../assets/images/offPremium/banner_mob_amarelo_1.jpg'
import bannerOffPremiumAmarelo2Mob from '../../assets/images/offPremium/banner_mob_amarelo_2.jpg'
import bannerOffPremiumRosa1Mob from '../../assets/images/offPremium/banner_mob_rosa_1.jpg'
import bannerOffPremiumRosa2Mob from '../../assets/images/offPremium/banner_mob_rosa_2.jpg'
import bannerAnimaleMob1 from '../../assets/images/Animale/Animale_mob_banner_1.png'
import bannerAnimaleMob2 from '../../assets/images/Animale/Animale_mob_banner_2.png'
import bannerAnimaleMob3 from '../../assets/images/Animale/Animale_mob_banner_3.png'
import bannerCrisBarrosMobile from '../../assets/images/bannerCrisBarrosMobileOptimized.svg'
import bannerFoxtonMobile from '../../assets/images/bannerFoxtonMobile.svg'

const foxton = [
    [bannerFoxtonMobile, bannerFoxton]
]
const lojaanimale = [
    [bannerAnimaleMob1, bannerAnimaleDesk1],
    [bannerAnimaleMob2, bannerAnimaleDesk2],
    [bannerAnimaleMob3, bannerAnimaleDesk3]
]
const lojacrisbarros = [
    [bannerCrisBarrosMobile, bannerCrisBarros]
]
const lojafabula = [
    [bannerFabulaMob1, bannerFabulaDesk1],
    [bannerFabulaMob2, bannerFabulaDesk2],
    [bannerFabulaMob3, bannerFabulaDesk3]
]
const lojafarm = [
    [bannerFarmMob, bannerFarmDesk]
]
const lojaoffpremium = [
    [bannerOffPremiumAmarelo1Mob, bannerOffPremiumAmarelo1Desk],
    [bannerOffPremiumAmarelo2Mob, bannerOffPremiumAmarelo2Desk],
    [bannerOffPremiumRosa1Mob, bannerOffPremiumRosa1Desk],
    [bannerOffPremiumRosa2Mob, bannerOffPremiumRosa2Desk]
]
const mariafilo = [
    [bannerMariaFiloMob1, bannerMariaFiloDesk1],
    [bannerMariaFiloMob2, bannerMariaFiloDesk2],
    [bannerMariaFiloMob3, bannerMariaFiloDesk3],
    [bannerMariaFiloMob4, bannerMariaFiloDesk4],
    [bannerMariaFiloMob5, bannerMariaFiloDesk5]
]

export const banners = [
    {
        name: 'foxton',
        banner: foxton
    },
    {
        name: 'lojaanimale',
        banner: lojaanimale
    },
    {
        name: 'lojacrisbarros',
        banner: lojacrisbarros
    },
    {
        name: 'lojafabula',
        banner: lojafabula
    },
    {
        name: 'lojafarm',
        banner: lojafarm
    },
    {
        name: 'lojaoffpremium',
        banner: lojaoffpremium,
    },
    {
        name: 'mariafilo',
        banner: mariafilo
    },

];
